import type { Draggable, PointerSensorOptions } from "@dnd-kit/dom";
import { PointerSensor } from "@dnd-kit/dom";

const MIDDLE_BUTTON = 1;

/**
 * Extends PointerSensor to allow both left-click (button 0) and middle-click (button 1)
 * to initiate drag operations. The default PointerSensor only allows left-click.
 *
 * For middle-click events, we wrap the event in a Proxy that reports button as 0
 * so that the parent's button guard (`event.button !== 0`) passes through.
 */
export class MiddleClickPointerSensor extends PointerSensor {
  protected override handlePointerDown(
    event: PointerEvent,
    source: Draggable,
    options: PointerSensorOptions | undefined,
  ): void {
    if (event.button === MIDDLE_BUTTON) {
      const proxiedEvent = new Proxy(event, {
        get(target, prop) {
          if (prop === "button") return 0;
          const value = Reflect.get(target, prop);
          return typeof value === "function" ? value.bind(target) : value;
        },
        set(target, prop, value) {
          return Reflect.set(target, prop, value);
        },
      });
      super.handlePointerDown(proxiedEvent, source, options);
      return;
    }
    super.handlePointerDown(event, source, options);
  }
}
